import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router";
import PropTypes from "prop-types";
import {
  findSubscription,
  setSubscription
} from "./acoes/MySubscriptionsActions";
import { buscarSubmissoesPorCPF } from "./acoes/ApiActions";
import NotificationSystem from "react-notification-system";
import logoBranco from "../../assets/img/logo-min.svg";
import logo from "../../assets/img/logo.svg";
import { View, MaskField, Form, Dialog, ButtonFields } from "react-template";
import "material-design-lite/material.min.css";
import "../../assets/css/view/inicio/index.css";
import "../../assets/css/app.css";
import { consultaCEP } from "../gru/actions/GRUActions";

class Index extends View {
  constructor(props) {
    super(props);
    this.valorCPF = this.valorCPF.bind(this);
    this.consultarCPF = this.consultarCPF.bind(this);
    this.state = {
      displayDialog: false,
      modalTitle: "",
      modalDescription: "",
      modalBody: "",
      onAgree: null,
      onCancel: null,
      cpfUsuario: "",
      errorFields: {}
    };
  }

  getDialog() {
    if (this.state.displayDialog) {
      return (
        <Dialog
          modalTitle={this.state.modalTitle}
          modalDescription={this.state.modalDescription}
          onAgree={this.state.onAgree}
          onCancel={this.state.onCancel}
          displayFunction={this.setDisplayModal}
        >
          {this.state.modalBody}
        </Dialog>
      );
    }
  }

  getChildContext() {
    return {
      setModalConfig: this.setModalConfig,
      setDisplayModal: this.setDisplayModal,
      notificationSystem: this.getNotificationSystem
    };
  }

  setModalConfig = (title, description, content, onAngree, onCancel) => {
    this.setState({
      modalTitle: title,
      modalBody: content,
      modalDescription: description,
      onAgree: onAngree,
      onCancel: onCancel
    });
  };

  setDisplayModal = boolean => {
    this.setState({ displayDialog: boolean });
  };

  getNotificationSystem = () => this.notificationSystem;

  valorCPF(e) {
    let valor = e.target.value;
    this.props.findSubscription(valor);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 2000);
  }

  consultarCPF(valor_cpf) {
    buscarSubmissoesPorCPF(
      valor_cpf,
      res => {
        const submissoes = res.data.content;
        if (submissoes.length > 0) {
          this.props.setSubscription(res.data.content);
          this.props.findSubscription(valor_cpf);
          this.redirect("/inscricoes");
        } else {
          this.notifyWarning("Nenhum inscrição encontrada", "");
        }
      },
      error => {
        this.notifyError("Erro", "Erro ao buscar inscrições");
      }
    );
  }

  keyHandler(event) {
    if (event.key === "Enter") {
      // event.shiftKey ? search() : add(description)
      this.consultarCPF(this.props.cpf);
    }
  }

  onSubmit = e => {
    e.preventDefault();
    this.consultarCPF(this.state.cpfUsuario);
  };

  handlerChangeTarget = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    return (
      <div className="box" id="p-inicio">
        {this.getDialog()}
        <NotificationSystem ref={n => (this.notificationSystem = n)} />
        <header className="menu-top">
          <div id="op-left">
            <Link to="/" className="logo-top">
              <img src={logo} height="35px" alt="logo UEPB" />
              <b>UEPB </b>&nbsp;| Forms
            </Link>

            <div id="consultar">
              <Form
                id="form-search-cpf"
                className="ui form"
                onSubmit={this.onSubmit.bind(this)}
              >
                <MaskField
                  name="cpfUsuario"
                  label="Consultar Inscrição (CPF)"
                  mask="999.999.999-99"
                  placeholder="000.000.000-00"
                  value={this.state.cpfUsuario}
                  onChange={this.handlerChangeTarget}
                  invalidMessage={
                    "O valor informado deve ser no padrão do cpf (999.999.999.99)"
                  }
                  pattern="\d{3}.\d{3}.\d{3}-\d{2}"
                  number
                  validateMessage={this.state.errorFields.cpfUsuario}
                  buttonAction={this.onSubmit.bind(this)}
                  buttonPosition="right"
                  buttonIcon="search"
                />
              </Form>
            </div>
          </div>

          <div id="op-right">
            <div id="entrar">
              <div
                className="d-flex flex-column"
                title="Login de Administradores"
                mini
                onClick={() => {
                  this.redirect("/login");
                }}
              >
                <ButtonFields content="Entrar" button="button" block />
              </div>
            </div>
          </div>
        </header>

        <div
          style={{
            backgroundColor: "rgb(243, 240, 240)",
            minHeight: "calc(100vh - 150px)"
          }}
        >
          {this.props.children}
        </div>

        <footer title="Rodapé Site UEPB">
          <div id="rodape-pagina-inicial">
            <div id="logo-uepb">
              <div>
                <section>
                  <img src={logoBranco} alt="logo UEPB" />
                </section>
                <section>UEPB</section>
              </div>
              <div>
                Desenvolvido por: CTIC <br />
                Coordenadoria de Tecnologia da Informação e Comunicação <br />
              </div>
            </div>
            <div id="enredeco-uepb">
              © {new Date().getFullYear()} UEPB - Universidade Estadual da
              Paraíba - CNPJ: 12.671.814/0001-37 <br />
              Rua Baraúnas, 351 - Bairro Universitário - Campina Grande-PB, CEP
              58429-500, Fone/Fax: 83 3315.3300
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

Index.childContextTypes = {
  setModalConfig: PropTypes.func,
  setDisplayModal: PropTypes.func,
  notificationSystem: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cpf: state.MySubscriptionsReducers.cpf
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ findSubscription, setSubscription }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);



// WEBPACK FOOTER //
// ./src/view/inicio/index.js